import type { FC, PropsWithChildren, ReactNode } from "react";
import ButtonWithContextMenu from "../buttonWithContextMenu/ButtonWithContextMenu";
import type { SxProps } from "@mui/material";

export interface DownloadOption {
  readonly name: string;
  readonly apiDefinition: () => Promise<Blob>;
  readonly disabled?: boolean;
}

interface Props {
  readonly loading: boolean;
  readonly options: Pick<DownloadOption, "name" | "disabled">[];
  readonly icon: ReactNode;
  readonly variant?: "outlined" | "contained" | "text";
  readonly color?: "primary" | "secondary" | "error" | "inherit";
  readonly sx?: SxProps;
  onDownload: (key: string) => Promise<void>;
}

const MultiOptionDownloadButton: FC<PropsWithChildren<Props>> = ({
  loading,
  options,
  icon,
  variant,
  color,
  children,
  sx,
  onDownload,
}) => (
  <ButtonWithContextMenu
    loading={loading}
    startIcon={icon}
    variant={variant}
    color={color}
    sx={sx}
    menuItems={options.map((o) => ({ name: o.name, disabled: o.disabled, onClick: () => onDownload(o.name) }))}
  >
    {children}
  </ButtonWithContextMenu>
);

export default MultiOptionDownloadButton;
